import { AppUser, RolePermissions } from '../types/auth';

// Seeded from "Users and Roles.xlsx" (OneDrive/Engineering and Technology/Software Engineering/
// Internal Tools/). This list is the initial state on first load; localStorage takes over after.
// Admins listed in workbook: Jared Archuleta, Abdullah Bilal, Kevin Magallon.
export const SEED_USERS: AppUser[] = [
  { firstName: 'Jared',    lastName: 'Archuleta', email: 'jared@flameco.com',         role: 'Admin' },
  { firstName: 'Abdullah', lastName: 'Bilal',     email: 'abilal@flameco.com',        role: 'Admin' },
  { firstName: 'Kevin',    lastName: 'Magallon',  email: 'kmagallon@flameco.com',     role: 'Admin' },
  { firstName: 'Dwight',   lastName: 'Brooker',   email: 'paradoxip@outlook.com',     role: 'Paradox' },
  { firstName: 'Robert',   lastName: 'Archuleta', email: 'robert@flameco.com',        role: 'Viewer' },
  { firstName: 'Rob',      lastName: 'Cruzen',    email: 'rob@flameco.com',           role: 'Viewer' },
  { firstName: 'Jeremy',   lastName: 'Young',     email: 'jyoung@flameco.com',        role: 'Viewer' },
  { firstName: 'Michael',  lastName: 'Swain',     email: 'michael@flameco.com',       role: 'Viewer' },
  { firstName: 'Luke',     lastName: 'Bean',      email: 'luke@flameco.com',          role: 'Viewer' },
  { firstName: 'David',    lastName: 'Dunlap',    email: 'david@flameco.com',         role: 'Viewer' },
  { firstName: 'Jess',     lastName: 'Salcido',   email: 'jess@flameco.com',          role: 'Viewer' },
  { firstName: 'John',     lastName: 'Danne',     email: 'john@flameco.com',          role: 'Viewer' },
  { firstName: 'John',     lastName: 'Dorris',    email: 'jdorris@flameco.com',       role: 'Viewer' },
  { firstName: 'Cody',     lastName: 'Conley',    email: 'cody@flameco.com',          role: 'Viewer' },
  { firstName: 'Scott',    lastName: 'Comar',     email: 'scomar@flameco.com',        role: 'Viewer' },
  { firstName: 'Grant',    lastName: 'Archuleta', email: 'grant@flameco.com',         role: 'Viewer' },
  { firstName: 'Eric',     lastName: 'Dunn',      email: 'eric@flameco.com',          role: 'Viewer' },
  { firstName: 'Andrew',   lastName: 'Dingman',   email: 'adingman@flameco.com',      role: 'Viewer' },
];

// NetSuite internal IDs that always resolve to Admin on the Flameco employee
// login path. That path derives role from the shipping-app JWT — NOT from the
// email-keyed SEED_USERS above, whose emails can't match the synthetic
// `<internalId>@netsuite.flameco` identity — so admins must be listed here by
// internalId. Keep in sync with the Admins in SEED_USERS:
//   -5    = Archuleta, Jared     (Engineering and Technology Manager)
//   10045 = Bilal, Abdullah M    (Software Engineer)
//   7840  = Magallon, Kevin S    (Business Systems Engineer)
export const ADMIN_INTERNAL_IDS = new Set<string>(['-5', '10045', '7840']);

// Default role-permissions matrix. Admin is hard-coded to "everything" elsewhere.
// Paradox: per user request — only the two engineering-calculator modules.
// Viewer: preserves the prior "everyone has access" default for production tools.
// laser-quote is granted to Viewer so it appears on the home page. NOTE: it exposes
// the full cost stack + margins — restrict per-role via User Management if that data
// should be limited. Paradox (external partner) is intentionally excluded.
export const DEFAULT_ROLE_PERMISSIONS: RolePermissions = {
  // Manager: every module EXCEPT User and Role Management (that stays Admin-only).
  Manager: ['mto-configurator', 'flame-cell-calculator', 'production-planning', 'threaded-inline-arrestors', 'tribal-knowledge', 'laser-quote', 'balanced-strategic-plan'],
  Paradox: ['threaded-inline-arrestors', 'flame-cell-calculator'],
  Viewer:  ['mto-configurator', 'flame-cell-calculator', 'production-planning', 'threaded-inline-arrestors', 'tribal-knowledge', 'laser-quote'],
};
